import { FC } from 'react';
import {
	ButtonContainer,
	ButtonWrapper,
	ChildrenContainer,
	Container,
	Content,
	Title,
	TitleContainer,
} from './Modal.styles';
import { Dialog } from '@mui/material';
import { Button } from '../button';
import { CancelOutlined } from '@mui/icons-material';

interface ModalProps {
	open: boolean;
	onClose: () => void;
	title: string;
	children: React.ReactNode;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	onPrimaryButtonClick?: () => void;
	onSecondaryButtonClick?: () => void;
}

const Modal: FC<ModalProps> = ({
	open,
	onClose,
	title,
	children,
	primaryButtonText,
	secondaryButtonText,
	onPrimaryButtonClick,
	onSecondaryButtonClick,
}) => {
	return (
		<Dialog open={open}>
			<Container>
				<Content>
					<TitleContainer>
						<Title>{title}</Title>
						<ButtonWrapper>
							<Button variant='text' onClick={onClose}>
								<CancelOutlined fontSize='large' />
							</Button>
						</ButtonWrapper>
					</TitleContainer>
					<ChildrenContainer>{children}</ChildrenContainer>
					<ButtonContainer>
						{!!secondaryButtonText && (
							<Button variant='text' onClick={onSecondaryButtonClick}>
								{secondaryButtonText}
							</Button>
						)}
						{!!primaryButtonText && (
							<Button fitContent variant='contained' onClick={onPrimaryButtonClick}>
								{primaryButtonText}
							</Button>
						)}
					</ButtonContainer>
				</Content>
			</Container>
		</Dialog>
	);
};

export default Modal;
